import { useState } from 'react';
import { IClientPassengerBrief } from '@bustickus/models-client';
import { Modal, Flex, Button, Loader } from 'components';
import { ApiPassengers } from 'common/api';
import './style.scss';

interface IProps {
  passenger: IClientPassengerBrief;
  onClose: () => void;
  onDeleted: () => void;
}

type Stage = 'default' | 'loading' | 'success' | 'error';

function ModalDeletePassengerConfirm(props: IProps) {
  const [stage, setStage] = useState<Stage>('default');

  const handleDeleteConfirm = async () => {
    setStage('loading');

    try {
      await ApiPassengers.getInstance().delete(props.passenger.id);
      props.onDeleted();
      setStage('success');
    } catch {
      setStage('error');
    }
  };

  return (
    <Modal
      header='Удаление пассажира'
      onClose={stage !== 'loading' ? props.onClose : undefined}
    >
      {stage === 'default' && (
        <DefaultStage
          onCancel={props.onClose}
          onConfirm={handleDeleteConfirm}
        />
      )}
      {stage === 'loading' && <LoadingStage />}
      {stage === 'success' && <SuccessStage onClose={props.onClose} />}
      {stage === 'error' && <ErrorStage onClose={props.onClose} />}
    </Modal>
  );
}

function SuccessStage(props: { onClose: () => void }) {
  return (
    <Flex
      direction='column'
      gap={20}
      className='modal-passenger-delete-pWGc'
    >
      <span className='delete-passenger-description-text-qVVZ'>Пассажир был успешно удалён из сервиса</span>
      <Button onClick={props.onClose}>Закрыть</Button>
    </Flex>
  );
}

function ErrorStage(props: { onClose: () => void }) {
  return (
    <Flex
      direction='column'
      gap={20}
      className='modal-passenger-delete-pWGc'
    >
      <span className='delete-passenger-description-text-qVVZ'>Произошла ошибка при удалении пассажира из сервиса</span>
      <Button onClick={props.onClose}>Закрыть</Button>
    </Flex>
  );
}

function LoadingStage() {
  return (
    <Flex
      className='modal-passenger-delete-pWGc modal-passenger-loader-cnt-rwaF'
      alignItems='center'
      justifyContent='center'
    >
      <Loader
        color='blue'
        size='default'
        variant='line'
      />
    </Flex>
  );
}

function DefaultStage(props: { onConfirm: () => void; onCancel: () => void }) {
  return (
    <Flex
      direction='column'
      gap={20}
      className='modal-passenger-delete-pWGc'
    >
      <span className='delete-passenger-description-text-qVVZ'>
        Вы действительно хотите удалить пассажира из сервиса?
      </span>
      <Flex
        gap={5}
        justifyContent='center'
      >
        <Button
          color='blue'
          onClick={props.onCancel}
          className='modal-button-hNuo'
        >
          Нет
        </Button>
        <Button
          color='red'
          onClick={props.onConfirm}
          className='modal-button-hNuo'
        >
          Да
        </Button>
      </Flex>
    </Flex>
  );
}

export default ModalDeletePassengerConfirm;
